module.exports = __webpack_public_path__ + "img/y-161.6445de13.png";